import React from 'react';
import { Badge } from '@/components/ui/badge';

interface RetraitTotalBubbleProps {
  itemCount: number;
  isVisible: boolean;
}

export const RetraitTotalBubble: React.FC<RetraitTotalBubbleProps> = ({ 
  itemCount, 
  isVisible 
}) => {
  if (!isVisible || itemCount === 0) return null;

  return (
    <div className="fixed top-20 right-4 z-50 animate-in slide-in-from-right-2 duration-300">
      <Badge 
        variant="default" 
        className="px-4 py-3 text-lg font-bold bg-orange-600 text-white shadow-lg border-2 border-orange-600/20"
      >
        {itemCount} article{itemCount > 1 ? 's' : ''} à retirer
      </Badge>
    </div>
  );
};